// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Text,
} from 'recharts';

// Enums
import { MatrixQuestionDataType } from 'engagementReport/enums/propTypes';

// Utilities
import { colors, rtlLanguage } from 'common/utils/helpers';

// Hooks
import useMatrixBarChartData from 'engagementReport/hooks/useMatrixBarChartData';

// Components
import MatrixTooltip from 'engagementReport/components/matrix/MatrixTooltip';

const MatrixVerticalBarChart = ({ data }) => {
  const chartData = useMatrixBarChartData(data);

  /* eslint-disable react/prop-types */
  return (
    <>
      <ResponsiveContainer width="100%" aspect={16 / 9}>
        <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
          <CartesianGrid vertical={false} stroke="#e8e8e8" strokeWidth={1} />
          <XAxis
            type="category"
            dataKey="label"
            tickLine={false}
            tick={(props) => (
              <Text {...props} width={props.width / data.options.length - 4} fontSize={14}>
                {props.payload.value}
              </Text>
            )}
            stroke="#636363"
            strokeWidth={1}
            interval={0}
          />
          <YAxis
            type="number"
            domain={[0, 100]}
            ticks={[0, 25, 50, 75, 100]}
            tickLine={false}
            unit="%"
            interval={0}
            axisLine={false}
            orientation={rtlLanguage() ? 'right' : 'left'}
          />
          <Tooltip
            content={<MatrixTooltip weights={data.weights} />}
            cursor={{ fill: 'rgba(100, 100, 100, 0.05)' }}
            isAnimationActive={false}
          />
          {data.weights.map(({ id, label }, index) => (
            <Bar
              key={id}
              weightId={id}
              name={label}
              dataKey={`values.${id}.percentage`}
              barSize={20}
              fill={colors[index % colors.length]}
              unit="%"
              stackId="meow"
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
      <Legend
        layout="vertical"
        width="100%"
        wrapperStyle={{ marginTop: '20px', position: 'static' }}
        payload={data.weights.map(({ id, label }, index) => ({
          id,
          type: 'square',
          value: label,
          color: colors[index % colors.length],
        }))}
      />
    </>
  );
  /* eslint-enable react/prop-types */
};

Legend.propTypes = {
  width: PropTypes.string.isRequired,
};

MatrixVerticalBarChart.propTypes = {
  data: MatrixQuestionDataType.isRequired,
};

export default MatrixVerticalBarChart;
